import React from 'react';
import { BrowserRouter, Route, Switch, Redirect, RouteComponentProps } from 'react-router-dom';
import AlunoPage from './Pages/Aluno/Index';
import FuncionarioPage from './Pages/Funcionario/Index';
import NotFoundPage from './Pages/NotFound';
import ProfessorPage from './Pages/Professor/Index';
import { Navbar, NavbarTitle, Container, Button, Background } from './Components';
import { inject, observer } from 'mobx-react';
import { AUTH_STORE, AuthStore } from './Store/Auth';
import styled from 'styled-components';
import Logo from './Assets/logo.png';
import { PageTitle } from './Pages/Shared/PageTitle';

interface IProps extends RouteComponentProps<string> {
  [AUTH_STORE]: AuthStore;
  redirect: string;
}

const StyledButton = styled(Button)`
  margin-left: auto;
`;

const StyledAnchor = styled.a`
  text-decoration: none;
`;

const App: React.FC<IProps> = inject(AUTH_STORE)(observer((props) => {
  const { redirect } = props;
  const authStore = props[AUTH_STORE];

  return (
    <>
      <Navbar color="primaryColor" isFlat={true}>
        <NavbarTitle>{authStore.currentUser.name}</NavbarTitle>
        <StyledButton type="button" color="primaryLightColor" onClick={authStore.logout}>Sair</StyledButton>
      </Navbar>
      <Background color="primaryColor" />
      <div style={{ textAlign: 'center', marginTop: '2rem' }}>
        <StyledAnchor href={`${props.match.path}${redirect}`} >
          <img style={{ width: '10rem' }} src={Logo} />
          <PageTitle />
        </StyledAnchor>
      </div>
      <Container phone="100%" tablet="75%">
        <BrowserRouter>
          <Switch>
            <Route path="/aluno" component={AlunoPage} />
            <Route path="/professor" component={ProfessorPage} />
            <Route path="/funcionario" component={FuncionarioPage} />
            <Route path="*" exact={true} component={NotFoundPage} />
          </Switch>
          {redirect !== '' && !props.location.pathname.includes(redirect) &&
            <Redirect to={redirect} />}
        </BrowserRouter>
      </Container>
    </>
  );
}));

export default App;
